/* eslint-disable eqeqeq */
import Api from "../../../../services/ServiceApi";
import Cookies from "js-cookie";
import { dynamicExternalFunction } from "./dynamicAction";
export const getFunctionNamebyActionId = {
  5: "stopTime",
  2: "Rejectjob",
  6: "startTime",
  7: "approveExclusion",
  8: "canceljob",
  13: "fixProblemDone",
  16: "assignSub",
  17: "subAckJob",
  21: "closeJob",
  23: "assignMM",
  24: "mmAckJob",
  25: "setLinkToEdit",
  27: "RequestAlarmClear",
  28: "callProgressive",
  29: "AlarmClear",
  30: "AlarmNotClear",
  35: "reqSmsOnSite",
  36: "reqSmsOffSite",
  38: "FixProblemStepTwoDone",
  40: "manageMM",
  41: "manageSub",
  42: "setLinktoCopy",
  43: "saveFixproblem",
  44: "approveFixProblem",
  45: "acceptanceReject",
};

export function dynamicFunction(
  CompanyId,
  OperatorId,
  ProjectId,
  Jobdetail,
  ToggleModal,
  setloding,
  setloadingText,
  setSpin,
  setstatusInfoModalMode,
  form,
  setshowReject = null
) {
  this.CompanyId = CompanyId;
  this.OperatorId = OperatorId;
  this.ProjectId = ProjectId;
  this.job_id = Jobdetail.job_id;
  this.job_progress_id = Jobdetail.job_progress_id;
  this.job_category_id = Jobdetail?.job_category_id;
  this.job_type_id = Jobdetail.job_type_id;
  this.setloding = setloding;
  this.setstatusInfoModalMode = setstatusInfoModalMode;
  this.setloadingText = setloadingText;
  this.setSpin = setSpin;
  this.userName = Cookies.get("username");
  this.form = form;
  this.btnMiddleware = function (funcName, btndetail) {
    if (funcName !== undefined) {
      this[funcName](btndetail);
    } else {
      this.goNextAndReload(btndetail)
        .then(() => {
          if (
            btndetail.external_url_type &&
            btndetail.external_url_type === "json"
          ) {
            this.setloadingText("Loading External URL");
            this.CallExternalurl(JSON.parse(btndetail.external_url));
          } else {
            this.setloadingText("Success");
            this.setSpin(false);
          }
        })
        .catch((err) => {
          this.setloadingText(`Error : ${err.err}`);
          this.setSpin(false);
        });
    }
  };
  this.saveFixproblem = function (btn) {
    form.submit();
  };
  this.FixProblemStepTwoDone = function (btn) {
    form.submit();
  };
  this.fixProblemDone = function () {
    form.submit();
  };
  this.apiGoNextAction = function (btn) {
    return Api.post("/job_detail/go_next_process", {
      ...btn,
      operator_id: this.OperatorId,
      project_id: this.ProjectId,
      job_id: this.job_id,
      job_progress_id: this.job_progress_id,
      location_lat: 0,
      location_long: 0,
      create_by: Cookies.get("username"),
      job_type_id: this.job_type_id,
    });
  };
  this.acceptanceReject = function () {
    setshowReject(true);
  };
  this.setLinkToEdit = function () {
    window.location.assign(
      `/MaxiOperation/Editjob/${this.CompanyId}/${this.OperatorId}/${this.ProjectId}/${this.job_id}`
    );
  };
  this.setLinktoCopy = function () {
    window.location.assign(
      `/MaxiOperation/copyjob/${this.CompanyId}/${this.OperatorId}/${this.ProjectId}/${this.job_id}`
    );
  };
  this.canceljob = function (btn) {
    ToggleModal.setShowCancelJob(true);
  };
  this.Rejectjob = function (btn) {
    ToggleModal.setShowRejectExclusion(true);
  };
  this.manageMM = function (btn) {
    ToggleModal.setShowManageMM(true);
  };
  this.manageSub = function (btn) {
    ToggleModal.setshowManagesub(true);
  };
  this.assignSub = function (btn) {
    ToggleModal.setshowAssignSub(true);
  };
  this.assignMM = function (btn) {
    ToggleModal.setshowAssignMM(true);
  };
  this.mmAckJob = function (btn) {
    ToggleModal.setshowmmAckjob(true);
  };
  this.subAckJob = function (btn) {
    ToggleModal.setshowSubackjob(true);
  };
  this.stopTime = function (btn) {
    ToggleModal.setshowstopTime(true);
  };
  this.reqSmsOnSite = function (btn) {
    ToggleModal.setshowSmsOn(true);
  };
  this.reqSmsOffSite = function (btn) {
    ToggleModal.setshowSmsOff(true);
  };
  this.approveExclusion = function (btn) {
    ToggleModal.setShowApproveExclusion(true);
  };
  this.callProgressive = function (btn) {
    this.AlarmBtn(btn, 3);
  };

  this.AlarmBtn = function (btn, type) {
    this.setloding(true);
    this.setloadingText("Insert Alarm Network");
    Api.post("job_detail/InsertAlarmNetwork", {
      company_id: this.CompanyId,
      operator_id: this.OperatorId,
      project_id: this.ProjectId,
      job_id: this.job_id,
      job_type_id: this.job_type_id,
      job_category_id: this.job_category_id,
      job_progress_id: this.job_progress_id,
      oper_job_alarm_network_type_id: type,
      oper_job_alarm_network_type_desc: "",
      create_by: Cookies.get("username"),
      ...btn,
    }).then((res) => {
      if (res.data.result.code === "P") {
        this.setloadingText("Insert Alarm Network Success");
        if (btn.external_url_type && btn.external_url_type === "json") {
          this.setloadingText("Loading External URL");
          this.CallExternalurl(JSON.parse(btn.external_url));
        } else {
          this.setSpin(false);
        }
      } else if (res.data.result.code === "F") {
        this.setstatusInfoModalMode("error");
        this.setloadingText(`Error : ${res.data.result?.showText}`);
        this.setSpin(false);
      }
    });
  };
  this.RequestAlarmClear = function (btn) {
    this.callProgressive(btn);
  };
  this.AlarmClear = function (btn) {
    this.AlarmBtn(btn, 1);
  };
  this.AlarmNotClear = function (btn) {
    this.AlarmBtn(btn, 2);
  };
  this.sendEmailCloseJob = function (btn) {
    return Api.post("job_detail/close_job", {
      company_id: this.CompanyId,
      operator_id: this.OperatorId,
      project_id: this.ProjectId,
      job_id: this.job_id,
      job_progress_id: this.job_progress_id,
      location_lat: 0,
      location_long: 0,
      create_by: Cookies.get("username"),
      ...btn,
    });
  };
  this.closeJob = function (btn) {
    this.setloding(true);
    this.setloadingText("Calling sendEmailCloseJob()");
    this.sendEmailCloseJob(btn).then((res) => {
      const { data, result } = res.data;
      if (result.code === "P") {
        this.setloadingText(result.description);
        if (btn.external_url_type && btn.external_url_type === "json") {
          this.setloadingText("Loading External URL");
          this.CallExternalurl(JSON.parse(btn.external_url));
        } else {
          this.setSpin(false);
        }
      } else {
        this.setSpin(false);
        this.setstatusInfoModalMode("error");
        this.setloadingText(`Error : ${result.description}`);
      }
    });
  };
  this.CallExternalurl = function (external) {
    if (external && external.length > 0) {
      external
        .filter(
          (s) =>
            s.external_config.company_id == this.CompanyId &&
            s.external_config.operator_id == this.OperatorId &&
            s.external_config.project_id == this.ProjectId
        )
        .map((datas) => {
          const data = datas.external_config;
          if (
            data.external_name &&
            data.external_name !== "" &&
            data.api_url &&
            data.api_url !== ""
          ) {
            dynamicExternalFunction[data.external_name](
              data.api_url,
              this.job_id
            )
              .then((res) => {
                if (res.data.Result?.Code === "P") {
                  this.setSpin(false);
                  this.setloadingText("Success");
                } else if (res.data.Result?.Code === "F") {
                  this.setloadingText(
                    "Error External URL : " + res.data.Result.ShowText
                  );
                  this.setstatusInfoModalMode("error");
                  this.setSpin(false);
                }
              })
              .catch((err) => {
                this.setloadingText("Error External URL : " + err);
                this.setstatusInfoModalMode("error");
                this.setSpin(false);
              });
          }
        });
    }
  };
  this.callApproveFixProblemApi = function (btn) {
    return Api.post("job_detail/approve_Fix_Probleam", {
      company_id: this.CompanyId,
      operator_id: this.OperatorId,
      project_id: this.ProjectId,
      job_id: this.job_id,
      job_progress_id: this.job_progress_id,
      create_by: Cookies.get("username"),
      location_lat: null,
      location_long: null,
      progress_Status_flag: "",
      jobtypeid: this.job_type_id,
      jobActionConfig: null,
      maTypeId: "CM",
      checkFlag: 1,
      next_process_flag: 1,
      ...btn,
    });
  };
  this.approveFixProblem = function (btn) {
    this.setloding(true);
    this.setloadingText("Loading Next Action");
    setTimeout(() => {
      this.callApproveFixProblemApi(btn).then((res) => {
        const { result } = res.data;
        if (result?.code === "P") {
          if (btn.external_url_type && btn.external_url_type === "json") {
            this.setloadingText("Loading External URL");
            this.CallExternalurl(JSON.parse(btn.external_url));
          } else {
            this.setloadingText("Success");
            this.setSpin(false);
          }
        } else {
          this.setloadingText(`Error : ${res.data.result?.showText}`);
          this.setSpin(false);
        }
      });
    }, 2000);
  };
  this.goNextAndReload = function (btn) {
    return new Promise((resolve, reject) => {
      this.setloding(true);
      this.setloadingText("Loading Next Action");
      setTimeout(() => {
        this.apiGoNextAction(btn)
          .then((res) => {
            const { result } = res.data;
            if (result.code === "P") {
              resolve({ success: true, err: null });
            } else {
              reject({ success: false, err: result?.showText });
            }
          })
          .catch((err) => reject({ success: false, err: err }));
      }, 2000);
    });
  };
  this.startTime = function (btn) {
    this.setloding(true);
    this.setloadingText("Loading Next Action");
    setTimeout(() => {
      this.callUpdateStartTime(btn)
        .then((res) => {
          const { result } = res.data;
          if (result.code === "P") {
            if (btn.external_url_type && btn.external_url_type === "json") {
              this.setloadingText("Loading External URL");
              this.CallExternalurl(JSON.parse(btn.external_url));
            } else {
              this.setloadingText("Success");
              this.setSpin(false);
            }
          } else {
            this.setloadingText(`Error : ${result.showText}`);
            this.setSpin(false);
          }
        })
        .catch((err) => {
          this.setloadingText(`Error : ${err.err}`);
          this.setSpin(false);
        });
    }, 2000);
  };
  this.callUpdateStartTime = function (btn) {
    return Api.post("job_detail/update_oper_job_starttime", {
      ...btn,
      JobStopID: null,
      operator_id: this.OperatorId,
      project_id: this.ProjectId,
      job_id: this.job_id,
      job_progress_id: this.job_progress_id,
      location_lat: 0,
      location_long: 0,
      create_by: this.userName,
      job_type_id: this.job_type_id,
    });
  };
}
